import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import _get from 'lodash/get';
import { connect } from 'react-redux';

import FluidImg from 'Components/Utility/FluidImg';
import Price from 'Containers/Utility/Price/Price';
import { currencyCode } from 'Helpers/Geo/data';

import 'Components/Sales/GamesUnderBanner.scss';

const GamesUnderBanner = ({
  advertOverride,
  adverts,
  appearsOn,
  priceUnder,
  to,
  type,
}) => {
  let defaultImg = 'games-under-middle.jpeg';
  if (type === 'left') defaultImg = 'games-under-left.jpeg';
  if (type === 'right') defaultImg = 'games-under-right.jpeg';

  const gamesUnderBanner = _get(adverts, 'GamesUnder', []).find(ad => _get(ad, `appears_on[${appearsOn}]`));

  let customBannerImage = gamesUnderBanner?.images.find(img => img.img_type === `games_under_banner_${type}`);

  const bannerTextColor = gamesUnderBanner?.promotional_message_data?.text_colour || '#fff';

  // This is used for the GamesUnderBanner Preview
  if (advertOverride) customBannerImage = advertOverride?.images.find(img => img.img_type === `games_under_banner_${type}`);

  return (
    <Link to={to} className="games-under-banner-container">
      <div className="games-under-container">
        <div className="games-under-message">
          <div className="games-under-text" style={{ color: bannerTextColor }}>
            <FormattedMessage id="gamesunderbanner.gamesunder" defaultMessage="Games Under" />
          </div>
          <div className="games-under-price" style={{ color: bannerTextColor }}>
            <Price hideDecimals price={priceUnder} />
          </div>
        </div>
      </div>
      <div className="games-under-bg">
        <FluidImg
          folder="product"
          className="img-force-full"
          src={customBannerImage ? _get(customBannerImage, 'img') : defaultImg}
          alt={`Games under ${priceUnder[currencyCode]} `}
        />
      </div>
    </Link>
  );
};

GamesUnderBanner.propTypes = {
  advertOverride: PropTypes.shape({}),
  adverts: PropTypes.shape({}),
  appearsOn: PropTypes.oneOf([
    'home',
    'on_sale',
    'gift_guide',
    'black_friday',
  ]).isRequired,
  priceUnder: PropTypes.shape({
    CAD: PropTypes.number,
    USD: PropTypes.number,
    EUR: PropTypes.number,
    GBP: PropTypes.number,
    AUD: PropTypes.number,
    RUB: PropTypes.number,
    JPY: PropTypes.number,
  }).isRequired,
  to: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    'left',
    'middle',
    'right',
  ]).isRequired,
};

GamesUnderBanner.defaultProps = {
  adverts: {},
  appearsOn: 'home',
  type: 'left',
};

const mapStateToProps = ({ adverts }) => ({ adverts });

export default connect(mapStateToProps)(GamesUnderBanner);
